export default [
	    {
	        "id": "engagements__datetime",
	        "header": "Datetime",
	        "fieldName": "engagements__datetime",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 250 // MOD
	    },
	    {
	        "id": "engagements__preview",
	        "header": "Preview",
	        "fieldName": "engagements__preview",
	        "isSortable": false,
	        "isEditable": false,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 450 // MOD
	    },
	    {
	        "id": "engagements__screen_id",
	        "header": "Screen",
	        "fieldName": "screens__title",
	        "isSortable": true,
	        "isEditable": true,
	        "isReorderable": true,
	        "isResizable": true,
	        "w": 100,
	        "editField": "engagements__screen_id"
	    }
	];